import { useForm } from 'react-final-form'

import { mapErrorMessages } from 'utils/errorMessages'
import useStore from 'stores/utils/hooks/useStore'

import { useFieldMetadata } from 'context/fieldMetadata'

export function useError(path: string) {
  const { fieldErrors } = useStore()
  const form = useForm()
  const { errorMap } = useFieldMetadata(path)

  return {
    error: [
      mapErrorMessages(fieldErrors.get(path), errorMap),
      form.getFieldState(path)?.error
    ]
      .filter(Boolean)
      .join(' ')
  }
}
